export default "__VITE_ASSET__94a5dc96__"